import Utils from '../Utils';

export default class Transforms {
  private _transforms: Record<string, string>;

  constructor(transforms: Record<string, string>) {
    this.load(transforms);
  }

  public load(transforms: Record<string, string>) {
    this._transforms = transforms;
  }

  public get(key: string) {
    return this._transforms[key];
  }

  public set(key: string, val: string) {
    this._transforms[key] = val;
  }

  public getScale(key: string): CallableFunction {
    const transform = this._transforms[key];
    const scale = Utils.useScaleMap(transform);
    return scale;
  }
}
